import { createContext, useContext } from "react";

/**
 * Shared context that tells child components whether a page transition
 * is in progress and provides a way for pages to signal readiness.
 *
 * - `isTransitioning`: true while the GSAP curtain animation is running.
 * - `signalPageReady`: pages call this when their content is fully loaded.
 *   During SPA navigations, the curtain stays closed until the page signals
 *   ready and the numbered loader finishes counting to 100.
 */
export const PageTransitionContext = createContext({
    isTransitioning: false,
    signalPageReady: () => {},
});

export const usePageTransition = () => useContext(PageTransitionContext);